<script>
export default {
  props: ["clr", "borderClr"]
};
</script>
<template>
  <svg
    id="Verified-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20.003"
    viewBox="0 0 20 20.003"
  >
    <path id="Path_8553" data-name="Path 8553" d="M0,0H20V20H0Z" fill="none" />
    <path
      id="Path_8554"
      data-name="Path 8554"
      d="M3.55,14.629l1.328,1.738.287,2.164a2.68,2.68,0,0,0,2.3,2.3l2.169.29,1.737,1.327a2.679,2.679,0,0,0,3.255,0l1.738-1.328h0l2.165-.287a2.68,2.68,0,0,0,2.3-2.3l.289-2.169s.671-.878,1.328-1.737a2.681,2.681,0,0,0,0-3.255L21.124,9.635l-.287-2.164a2.68,2.68,0,0,0-2.3-2.3l-2.17-.289L14.628,3.551a2.679,2.679,0,0,0-3.255,0L9.635,4.878h0l-2.165.288a2.68,2.68,0,0,0-2.3,2.3l-.29,2.169s-.671.878-1.328,1.737a2.682,2.682,0,0,0,0,3.255Z"
      transform="translate(-3 -3)"
      :fill="borderClr ? borderClr : '#f3f5f9'"
    />
    <path
      id="Path_8556"
      data-name="Path 8556"
      d="M3.412,11.721l1,1.3.215,1.622A2.01,2.01,0,0,0,6.35,16.375l1.627.218,1.3.995a2.009,2.009,0,0,0,2.441,0l1.3-1h0l1.623-.215a2.01,2.01,0,0,0,1.728-1.727l.217-1.627,1-1.3a2.01,2.01,0,0,0,0-2.441l-.994-1.3-.215-1.623A2.01,2.01,0,0,0,14.65,4.625l-1.627-.217-1.3-.995a2.009,2.009,0,0,0-2.441,0l-1.3.995h0l-1.623.216A2.01,2.01,0,0,0,4.626,6.351L4.408,7.978l-1,1.3a2.012,2.012,0,0,0,0,2.441Z"
      transform="translate(-0.5 -0.5)"
      :fill="clr ? clr : '#00b947'"
    />
    <path
      id="Path_8555"
      data-name="Path 8555"
      d="M13.869,10.6l-2.918,2.917L9.2,11.769"
      transform="translate(-1.533 -1.767)"
      fill="none"
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
